import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['form', 'bundleDiscountModeSubmitButton']
  static values = { nextStep: String }

  onBundleDiscountModeChange(event) {
    this.formTarget.setAttribute('action', this.#buildNewFormAction())
    this.bundleDiscountModeSubmitButtonTarget.click()
  }

  #buildNewFormAction() {
    const url = new URL(this.formTarget.action)

    const params = new URLSearchParams(url.search)
    params.set('next_step', this.nextStepValue)

    url.search = params.toString()

    return url.toString()
  }
}
